import { Link } from 'react-router-dom';
import { aboutContent } from '@/mocks/aboutData';

export default function About() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '喑网91',
        url: 'https://echo64.cn/',
        description: '喑网91是值得信赖的综合网络服务平台，致力于通过技术驱动为用户提供安全、高效、智能的在线服务体验。',
        foundingDate: '2018',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          telephone: aboutContent.contact.phone,
          email: aboutContent.contact.email,
          availableLanguage: ['Chinese'],
          hoursAvailable: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            opens: '09:00',
            closes: '21:00',
          },
        },
        address: {
          '@type': 'PostalAddress',
          addressCountry: 'CN',
          streetAddress: aboutContent.contact.address,
        },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://echo64.cn/' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://echo64.cn/about' },
        ],
      },
      {
        '@type': 'WebPage',
        name: '关于喑网91 - 品牌介绍与联系我们',
        url: 'https://echo64.cn/about',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="min-h-screen bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-28 pb-16">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-8" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors no-underline">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">关于我们</span>
          </nav>

          <div className="mb-10">
            <h1
              className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              {aboutContent.brandIntro.title}
            </h1>
            <p className="text-sm md:text-base text-foreground-600">
              {aboutContent.brandIntro.description}
            </p>
          </div>

          {/* Brand Introduction */}
          <section className="mb-16">
            <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-start">
              <div className="w-full lg:w-3/5 space-y-5">
                {aboutContent.brandIntro.paragraphs.map((p, idx) => (
                  <p key={idx} className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {p}
                  </p>
                ))}
              </div>
              <div className="w-full lg:w-2/5">
                <div className="rounded-2xl overflow-hidden" style={{ aspectRatio: '4/3' }}>
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20amber%20and%20cream%20abstract%20background%20with%20soft%20geometric%20patterns%2C%20professional%20corporate%20atmosphere%2C%20clean%20minimal%20design%2C%20elegant%20flowing%20shapes%2C%20subtle%20gradient%20texture%2C%20peaceful%20and%20trustworthy%20feeling&width=600&height=450&seq=about-brand-yw91&orientation=landscape"
                    alt="喑网91 品牌介绍"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Core Values */}
          <section className="mb-16">
            <h2
              className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              核心价值观
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {aboutContent.values.map((v, idx) => (
                <div
                  key={idx}
                  className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center"
                >
                  <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                    <i className={`${v.icon} text-xl text-primary-600`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">{v.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{v.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Milestones */}
          <section className="mb-16">
            <h2
              className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              发展历程
            </h2>
            <div className="relative">
              <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-background-200/70 -translate-x-1/2"></div>
              <div className="space-y-6">
                {aboutContent.milestones.map((m, idx) => (
                  <div
                    key={idx}
                    className={`flex flex-col lg:flex-row items-start gap-4 lg:gap-0 ${
                      idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                    }`}
                  >
                    <div className={`w-full lg:w-1/2 ${idx % 2 === 0 ? 'lg:pr-12 lg:text-right' : 'lg:pl-12'}`}>
                      <div className={`p-4 rounded-lg bg-background-100 border border-background-200/70 ${idx % 2 === 0 ? 'lg:text-right' : ''}`}>
                        <span className="text-xs font-bold text-primary-600">{m.year}</span>
                        <p className="text-sm text-foreground-700 mt-1">{m.event}</p>
                      </div>
                    </div>
                    <div className="hidden lg:flex w-8 items-center justify-center z-10 shrink-0">
                      <div className="w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                    </div>
                    <div className="hidden lg:block w-full lg:w-1/2"></div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section id="reputation" className="mb-16">
            <h2
              className="text-xl md:text-2xl font-bold text-foreground-950 mb-3 text-center"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              {aboutContent.reputation.title}
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">{aboutContent.reputation.description}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {aboutContent.reputation.reviews.map((r, idx) => (
                <div
                  key={idx}
                  className="p-5 rounded-xl bg-background-100 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, si) => (
                      <i
                        key={si}
                        className={si < r.rating ? 'ri-star-fill text-xs text-amber-500' : 'ri-star-line text-xs text-amber-500'}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{r.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-sm font-semibold text-accent-700">{r.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-foreground-900">{r.name}</p>
                      <p className="text-xs text-foreground-500">{r.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="p-8 md:p-10 rounded-2xl bg-background-100 border border-background-200/70">
            <h2
              className="text-xl md:text-2xl font-bold text-foreground-950 mb-3 text-center"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              {aboutContent.contact.title}
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">{aboutContent.contact.description}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              <div className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-primary-600"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
                <a href={`mailto:${aboutContent.contact.email}`} className="text-sm text-foreground-900 font-medium hover:text-primary-600 transition-colors no-underline">
                  {aboutContent.contact.email}
                </a>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-phone-line text-primary-600"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">客服电话</p>
                <a href={`tel:${aboutContent.contact.phone}`} className="text-sm text-foreground-900 font-medium hover:text-primary-600 transition-colors no-underline">
                  {aboutContent.contact.phone}
                </a>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-wechat-line text-primary-600"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">官方微信</p>
                <p className="text-sm text-foreground-900 font-medium">{aboutContent.contact.wechat}</p>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-time-line text-primary-600"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">工作时间</p>
                <p className="text-sm text-foreground-900 font-medium">{aboutContent.contact.workingHours}</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}